const RETAIL_RECORDING_FEATURE_FLAG =
  "sales-experience-retail-recording" as const;

const MEDIA_RECORDER_TIMESLICE_MS = 15000;
const MEDIA_RECORDER_CHUNK_SECONDS = MEDIA_RECORDER_TIMESLICE_MS / 1000;

const BULK_UPLOAD_INTERVAL_MS = 5 * 60 * 1000;

// Client-side split threshold for a single `batch_upload` request. Kept below
// the backend's 25 MB decoded-payload cap (BATCH_UPLOAD_MAX_SIZE_BYTES) to leave
// margin. Measured against decoded blob bytes (not base64, which inflates ~33%).
const BATCH_UPLOAD_MAX_BYTES = 20 * 1024 * 1024;

// Skip-ahead buffer applied to the chunk index whenever a recording is resumed
// (same-tab refresh, browser relaunch, or cross-tab leader handoff), to guard
// against the last-persisted index being slightly stale.
const RESUME_CHUNK_INDEX_BUFFER = 10;

const LEADER_HEARTBEAT_INTERVAL_MS = 3000;
const LEADER_STALE_TIMEOUT_MS = 8000;
const LEADER_BROADCAST_CHANNEL_NAME = "retail-recording";

export {
  BATCH_UPLOAD_MAX_BYTES,
  BULK_UPLOAD_INTERVAL_MS,
  LEADER_BROADCAST_CHANNEL_NAME,
  LEADER_HEARTBEAT_INTERVAL_MS,
  LEADER_STALE_TIMEOUT_MS,
  MEDIA_RECORDER_CHUNK_SECONDS,
  MEDIA_RECORDER_TIMESLICE_MS,
  RESUME_CHUNK_INDEX_BUFFER,
  RETAIL_RECORDING_FEATURE_FLAG,
};
